import {jsx as _jsx} from "react/jsx-runtime";import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'







export const Loader = (props = {}) => {
  const {menuLoadingWidth, loadingDelay, size} = props

  return (
    _jsx(LoadingComponent, {
      delay: loadingDelay,
      spinnerSize: size || 24,
      height: menuLoadingWidth ? 24 : undefined,
      width: menuLoadingWidth,
      showAfter: menuLoadingWidth ? 0 : undefined,}
    )
  )
}
